import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Alert } from './Alert.vue';
export { default as AlertDescription } from './AlertDescription.vue';
export { default as AlertTitle } from './AlertTitle.vue';

export const alertVariants = cva(
  'tw-relative tw-w-full tw-rounded-lg tw-border tw-border-neutral-200 tw-px-4 tw-py-3 tw-text-sm [&>svg+div]:tw-translate-y-[-3px] [&>svg]:tw-absolute [&>svg]:tw-left-4 [&>svg]:tw-top-4 [&>svg]:tw-text-neutral-950 [&>svg~*]:tw-pl-7 dark:tw-border-neutral-800 dark:[&>svg]:tw-text-neutral-50',
  {
    variants: {
      variant: {
        default: 'tw-bg-white tw-text-neutral-950 dark:tw-bg-neutral-950 dark:tw-text-neutral-50',
        destructive:
          'tw-border-red-500/50 tw-text-red-500 dark:tw-border-red-500 [&>svg]:tw-text-red-500 dark:tw-border-red-900/50 dark:tw-text-red-900 dark:dark:tw-border-red-900 dark:[&>svg]:tw-text-red-900',
        warning:
          'tw-border-yellow-500/50 tw-bg-yellow-50 tw-text-yellow-900 dark:tw-border-yellow-500 [&>svg]:tw-text-yellow-600 dark:tw-border-yellow-900/50 dark:tw-bg-yellow-900/10 dark:tw-text-yellow-500 dark:[&>svg]:tw-text-yellow-500',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export type AlertVariants = VariantProps<typeof alertVariants>;
